/* src/app/shop/productos/product-variants/product-variants.component.scss */
b {
  font-size: 12px;
}
.option-card {
  border-radius: 15px;
  padding: 10px;
  gap: 15px;
  background-color: white;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.3019607843);
}
.optionsTitle {
  font-weight: 600;
  font-size: 18px;
  font-family: "Barlow Semi Condensed", sans-serif;
}
.option-label {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.option-label .option-name {
  font-weight: 500;
  font-size: 18px;
  font-family: "Barlow Semi Condensed", sans-serif;
  display: block;
  margin-right: 5px;
  text-transform: uppercase;
}
.option-label .option-value {
  font-size: 18px;
  text-transform: uppercase;
}
/*# sourceMappingURL=product-variants.component-CM4X3RVW.css.map */
